// One multipart upload: validate + compress (uploadPolicy), send, read the
// answer whatever it is (uploadResponse), retry a busy server.
//
// Resolves the server JSON on success. On failure it resolves
// { success:false, error, code, status } (the historical contract of the
// api*.js helpers, which never threw) -- or throws when `throwOnError`.
import { prepareUpload } from "./uploadPolicy";
import { readUploadResponse, withUploadRetry } from "./uploadResponse";

export const uploadFileRequest = async ({
  url,
  feature,
  file,
  field = "file",
  filename,
  method = "POST",
  headers = {},
  fields = {},
  retry = true,
  throwOnError = false,
}) => {
  try {
    const prepared = feature ? await prepareUpload(feature, file) : file;
    const send = async () => {
      const body = new FormData();
      Object.entries(fields).forEach(([key, value]) => { if (value !== undefined && value !== null) body.append(key, value); });
      if (filename) body.append(field, prepared, filename);
      else body.append(field, prepared);
      return readUploadResponse(await fetch(url, { method, headers, body }));
    };
    return await (retry ? withUploadRetry(send) : send());
  } catch (error) {
    if (throwOnError) throw error;
    return { success: false, error: error.message || "L'envoi du fichier a échoué.", code: error.code, status: error.status };
  }
};

// Several files, one request each, one after the other.
export const uploadFilesSequentially = async (files, upload) => {
  const results = [];
  for (const file of files) results.push(await upload(file));
  return results;
};
